// App.js (sin Router)
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Header from './components/Header';
import Footer from './components/Footer';
import './index.css';

function App() {
   const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('crokchef_cart');
    return saved ? JSON.parse(saved) : [];
  });
  const [isCartOpen, setIsCartOpen] = useState(false);

    // 💾 Guardar en localStorage cada vez que cambie el carrito
  useEffect(() => {
    localStorage.setItem('crokchef_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const getTotalItems = () => {
    return cartItems.reduce((sum, item) => sum + item.quantity, 0);
  };

  const getTotalPrice = () => {
    return cartItems.reduce((sum, item) => {
      // Asegurar que precio sea número
      const price = typeof item.precio === 'number' ? item.precio : parseFloat(item.precio || 0);
      return sum + (isNaN(price) ? 0 : price) * item.quantity;
    }, 0);
  };

  const addToCart = (product) => {
    const price = product.es_oferta && product.precio_oferta
      ? parseFloat(product.precio_oferta)
      : parseFloat(product.precio_base);
    const finalPrice = isNaN(price) ? 0 : price;

    const existing = cartItems.find(item => item.id === product.id);
    if (existing) {
      // ...
    } else {
      const newItem = {
        ...product,      // copia todas las propiedades
        precio: finalPrice,
        quantity: 1
      };
      setCartItems([...cartItems, newItem]);
    }
  };

  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      setCartItems(prev => prev.filter(item => item.id !== productId));
      return;
    }
    setCartItems(prev =>
      prev.map(item =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  return (
      <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--background-color)' }}>
        <Header
          cartItemsCount={getTotalItems()}
          onCartToggle={() => setIsCartOpen(!isCartOpen)}
        />
        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  cartItems={cartItems}
                  addToCart={addToCart}
                  updateQuantity={updateQuantity}
                  getTotalItems={getTotalItems}
                  getTotalPrice={getTotalPrice}
                  isCartOpen={isCartOpen}
                  setIsCartOpen={setIsCartOpen}
                />
              }
            />
            <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
  );
}

export default App;